import { z } from "zod";
import type { GenericSize } from "./geom.ts";

type NumberOfBasePlatesDimension = number;

type NumberOfBaseplates = GenericSize<NumberOfBasePlatesDimension>;

const basePlateSizeSchema = z.number().int().positive();

type BaseplateSize = z.infer<typeof basePlateSizeSchema>;

const knownBasePlateSizes = [
	{
		size: 24,
		abbreviation: "SB",
		numberOfBasePlatesPerPackaging: 9,
	},
	{
		size: 32,
		abbreviation: "LB",
		numberOfBasePlatesPerPackaging: 8,
	},
];

const maxNumberOfBaseplates = 20;

function getKnownBasePlateSize(size: BaseplateSize) {
	return knownBasePlateSizes.find((s) => s.size === size);
}

const maxKnownBasePlateSize = Math.max(
	...knownBasePlateSizes.map((s) => s.size),
);

function basePlateSizeAbbreviation(size: BaseplateSize) {
	return getKnownBasePlateSize(size)?.abbreviation ?? size.toString();
}

export type { BaseplateSize, NumberOfBaseplates, NumberOfBasePlatesDimension };
export {
	basePlateSizeAbbreviation,
	basePlateSizeSchema,
	maxKnownBasePlateSize,
	getKnownBasePlateSize,
	maxNumberOfBaseplates,
};
